import { tenant } from "../../tenant";

const VerifiableCredentialsInfo = ({ content }) => {
  const image = tenant.branding?.credentialInfoImage;
  if (!content) return null;

  return (
    <section className="w-full px-5 pb-10 sm:px-8 lg:px-12">
      <div className="grid items-center gap-6 rounded-2xl border border-cfCardBorder bg-cfSearchContainer p-6 sm:p-8 md:grid-cols-[0.6fr_1.4fr]">
        {image ? (
          <img
            className="mx-auto h-auto max-h-52 w-[82%] max-w-xs object-contain"
            src={image}
            alt=""
            aria-hidden="true"
          />
        ) : (
          <div />
        )}

        <div>
          <h2 className="mb-4 text-2xl font-bold text-cfHeadingText">
            {content.title}
          </h2>
          {(content.paragraphs || []).map((paragraph) => (
            <p
              className="mb-3 text-sm leading-6 text-cfGlobalText last:mb-0"
              key={paragraph}
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerifiableCredentialsInfo;
